export default (plannerProfileList: string): string => `
-- Here are the smart planner profiles the user has created so far and that is currently showing in the dashboard --
    
${plannerProfileList}

If the user asks anything about any of these smart planner profiles, answer to the best of your ability.  If you're unable to derive the answer from this list, prompt the user to open the profile, and then ask the question again.  Render your response using markdown.

If you render the name of any profile, use the profile's name as a link to the profile.  For example, if the profile's name is "My First Planning Profile" with an id of "123", you should render it as [My First Planning Profile](/planner/123).
`;
